var n;
((e) => {
  function t(i, l, p = null, u = !1) {
  }
  e.setupMixpanel = t;
  function a(i, l = {}) {
  }
  e.sendMixpanelEvent = a;
})(n || (n = {}));
export {
  n as Mixpanel
};
